<!-- BEGIN: Topbar -->
<div class="kt-header__topbar">
    <ng-container *ngIf="isWebshopAvailable && package  && 'Pages.App.Webshop.View.ShowPalletsInfo' | permission">
        <div class="kt-header__topbar-item dropdown">
            <div class="kt-header__topbar-wrapper" (click)="goToBasket()">
                <div class="pallets-panel">
                    <ng-container *ngFor="let pallet of packagePallets">
                        <app-small-pallet [pallet]="pallet"></app-small-pallet>
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>
    <div class="kt-header__topbar-item dropdown" *ngIf="ifUserHasOu">
        <div class="kt-header__topbar-wrapper virtual-bank-info">
            <p-dropdown [options]="ddOus"
                        [style]="{'width':'100%', 'min-width':'100%'}"
                        [(ngModel)]="selectedOu"
                        (onChange)="changeOu($event.value)"></p-dropdown>
        </div>
    </div>
    <div class="kt-header__topbar-item" *ngIf="isBlocked">
        <div class="kt-header__topbar-wrapper blocked-ou">
            <strong translation="Axilla.App.Webshop.IsUserOuBlocked" source="Axilla"></strong>
        </div>
    </div>
    <div class="kt-header__topbar-item dropdown" *ngIf="virtualBankAccount != null">
        <div class="kt-header__topbar-wrapper virtual-bank-info">
            <span *ngIf="virtualBankAccount.legalName">
                {{virtualBankAccount.legalName}}
            </span>
            <span *ngIf="virtualBankAccount.externalUserReference">
                ({{virtualBankAccount.externalUserReference}})
            </span>
        </div>
    </div>
    <div class="kt-header__topbar-item dropdown" *ngIf="isAmountFitMinimumAmountRequirements && 'Pages.App.Webshop.View.HasMOV' | permission">
        <div class="kt-header__topbar-wrapper webshop-basket-container minimum-amount" [ngClass]="{'dissabled-basket' : itemsCount === 0}" (click)="goToBasket()">
            <span translation="Axilla.Webshop.LabelForMinimumAmount"></span>  &nbsp;
            <span id="minimumAmount">
                {{minimumAmount | currency:getCurrency():'symbol-narrow':'.2-2'}}
            </span>
        </div>
    </div>
    <div class="kt-header__topbar-item dropdown" *ngIf="isWebshopAvailable">
        <div class="kt-header__topbar-wrapper webshop-basket-container"  [ngClass]="{'dissabled-basket' : itemsCount === 0, 'minimum-amount': isAmountFitMinimumAmountRequirements && 'Pages.App.Webshop.View.HasMOV' | permission }" (click)="goToBasket()">
            <span id="currentAmount">
                {{totalItemAmount | currency:getCurrency():'symbol-narrow':'.2-2'}}
            </span>
        </div>
    </div>
    <div class="kt-header__topbar-item dropdown" *ngIf="isWebshopAvailable">
        <div class="kt-header__topbar-wrapper" [ngClass]="{'dissabled-basket' : itemsCount === 0}" (click)="goToBasket()">
            <span class="kt-header__topbar-icon kt-header__topbar-icon--brand">
                <i class="flaticon-shopping-basket"></i>
                <div class="kt-badge kt-badge--primary unread-notification-count" *ngIf="itemsCount > 0">
                    {{itemsCount}}
                </div>
            </span>
        </div>
    </div>
    <ng-container *ngIf="FeatureDefinition.Webshop.FavoriteArticles | checkFeature">
        <div class="kt-header__topbar-item dropdown">
            <div class="kt-header__topbar-wrapper" (click)="goToFavorites()">
                <span class="kt-header__topbar-icon kt-header__topbar-icon--brand">
                    <i class="fa fa-heart favorite"></i>
                    <div class="kt-badge kt-badge--primary unread-notification-count" *ngIf="favoritesItemsCount > 0">
                        {{favoritesItemsCount}}
                    </div>
                </span>
            </div>
        </div>
    </ng-container>
    <div dropdown class="kt-header__topbar-item dropdown dropdown-language" aria-haspopup="true" *ngIf="languages.length > 1">
        <div dropdownToggle class="kt-header__topbar-wrapper" data-toggle="dropdown" data-offset="30px,0px" aria-expanded="true">
            <span class="kt-header__topbar-icon kt-header__topbar-icon--brand">
                <i [class]="currentLanguage.icon"></i>
            </span>
        </div>
        <div *dropdownMenu class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg" [attr.aria-label]="l('Languages')">
            <ul class="kt-nav kt-margin-t-10 kt-margin-b-10">
                <li class="kt-nav__item" *ngFor="let language of languages">
                    <a class="kt-nav__link" (click)="changeLanguage(language.name)">
                        <span class="kt-nav__link-icon">
                            <i [class]="language.icon"></i>
                        </span>
                        <span class="kt-nav__link-text">
                            {{language.displayName}}
                        </span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div *ngIf="!getSession()" class="kt-header__topbar-item dropdown">
        <div class="kt-header__topbar-wrapper virtual-bank-info">
            <span>
                <a (click)="login()" class="btn btn-label-brand btn-bold">{{"Log In" | localize}}</a>
            </span>
        </div>
    </div>
    <div *ngIf="getSession()" headerNotifications class="kt-header__topbar-item dropdown" dropdown id="header_notification_bar"></div>
    <div *ngIf="getSession()" class="kt-header__topbar-item kt-header__topbar-item--user" style="position: relative" dropdown>
        <div class="kt-header__topbar-wrapper" data-toggle="dropdown" data-offset="0px,0px" aria-expanded="false" dropdownToggle>


            <div class="kt-header__topbar-user">
                <i *ngIf="isImpersonatedLogin" class="fa fa-reply kt-font-danger mr-2"></i>
                <span class="kt-header__topbar-username kt-hidden-mobile">
                    <span *ngIf="isMultiTenancyEnabled" class="tenancy-name">{{tenancyName}}\</span>{{userName}}
                </span>
                <img *ngIf="profilePicture" class="header-profile-picture m--img-rounded m--marginless m--img-centered" alt="Pic" [src]="profilePicture">
            </div>
        </div>
        <div *dropdownMenu class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl" x-placement="bottom-end" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(1253px, 64px, 0px);">
            <div class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x" [ngStyle]="{ 'background': 'url(' + appRootUrl() + 'assets/metronic/themes/' + currentTheme.baseSettings.theme + '/images/bg/bg-1.jpg)', 'background-size': 'cover'}">
                <div class="kt-user-card__avatar">
                    <img class="" alt="Pic" [src]="profilePicture">
                </div>
                <div class="kt-user-card__name">
                    <span *ngIf="isMultiTenancyEnabled" class="tenancy-name">{{tenancyName}}\</span>{{userName}}
                </div>
            </div>
            <div class="kt-notification">
                <a *ngIf="isImpersonatedLogin" href="javascript:;" class="kt-notification__item" (click)="backToMyAccount()">

                    <div class="kt-notification__item-icon">
                        <i class="fa fa-reply kt-font-danger"></i>
                    </div>
                    <div class="kt-notification__item-details">
                        <div class="kt-notification__item-title kt-font-bold">
                            <span>
                                {{"BackToMyAccount" | localize}}
                            </span>
                        </div>
                    </div>
                </a>

                <a *ngIf="'Pages.Environment.Administration.Users' | permission" routerLink="admin/users" class="kt-notification__item">
                    <div class="kt-notification__item-icon">
                        <i class="flaticon-user-settings"></i>
                    </div>
                    <div class="kt-notification__item-details">
                        <div class="kt-notification__item-title kt-font-bold">
                            <span translation="Axilla.Management.Users" source="Axilla"></span>
                        </div>
                    </div>
                </a>

                <ng-container *ngIf="isLinkAccountEnable">
                    <a href="javascript:;" class="kt-notification__item linked-accounts" (click)="showLinkedAccounts()">
                        <div class="kt-notification__item-icon">
                            <i class="flaticon-user-settings"></i>
                        </div>
                        <div class="kt-notification__item-details">
                            <div class="kt-notification__item-title kt-font-bold">
                                <span>
                                    {{"ManageLinkedAccounts" | localize}}
                                </span>
                            </div>
                        </div>
                    </a>
                </ng-container>

                <div class="kt-notification__custom py-0 linked-accounts">
                    <ul class="kt-nav linked-accounts" *ngIf="recentlyLinkedUsers"
                        [attr.aria-label]="l('LinkedAccounts')">
                        <li *ngFor="let linkedUser of recentlyLinkedUsers" class="kt-nav__item py-2">
                            <a href="javascript:;" (click)="switchToLinkedUser(linkedUser)" class="recently-linked-user">

                                <span class="kt-nav__link-bullet">
                                    <span></span>
                                </span>
                                <span class="kt-nav__link-text">
                                    {{getShownUserName(linkedUser)}}
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
                <a href="javascript:;" class="kt-notification__item" (click)="changePassword()">
                    <div class="kt-notification__item-icon">
                        <i class="flaticon-more-v6"></i>
                    </div>
                    <div class="kt-notification__item-details">
                        <div class="kt-notification__item-title kt-font-bold">
                            <span>
                                {{"ChangePassword" | localize}}
                            </span>
                        </div>
                    </div>
                </a>
                <a href="javascript:;" class="kt-notification__item" (click)="showLoginAttempts()">
                    <div class="kt-notification__item-icon">
                        <i class="flaticon-list"></i>
                    </div>
                    <div class="kt-notification__item-details">
                        <div class="kt-notification__item-title kt-font-bold">
                            <span>
                                {{"LoginAttempts" | localize}}
                            </span>
                        </div>
                    </div>
                </a>
                <a href="javascript:;" class="kt-notification__item" (click)="changeProfilePicture()">
                    <div class="kt-notification__item-icon">
                        <i class="flaticon-profile-1"></i>
                    </div>
                    <div class="kt-notification__item-details">
                        <div class="kt-notification__item-title kt-font-bold">
                            <span>
                                {{"ChangeProfilePicture" | localize}}
                            </span>
                        </div>
                    </div>
                </a>
                <a href="javascript:;" class="kt-notification__item" (click)="changeMySettings()">
                    <div class="kt-notification__item-icon">
                        <i class="flaticon-cogwheel"></i>
                    </div>
                    <div class="kt-notification__item-details">
                        <div class="kt-notification__item-title kt-font-bold">
                            <span>
                                {{"MySettings" | localize}}
                            </span>
                        </div>
                    </div>
                </a>
                <a *ngIf="'Pages.Administration.UiCustomization' | permission" routerLink="admin/ui-customization" class="kt-notification__item">

                    <div class="kt-notification__item-icon">
                        <i class="flaticon-medical"></i>
                    </div>
                    <div class="kt-notification__item-details">
                        <div class="kt-notification__item-title kt-font-bold">
                            <span>
                                {{"VisualSettings" | localize}}
                            </span>
                        </div>
                    </div>
                </a>
                <a href="javascript:;" class="kt-notification__item" (click)="downloadCollectedData()">
                    <div class="kt-notification__item-icon">
                        <i class="flaticon-download"></i>
                    </div>
                    <div class="kt-notification__item-details">
                        <div class="kt-notification__item-title kt-font-bold">
                            <span>
                                {{"DownloadCollectedData" | localize}}
                            </span>
                        </div>
                    </div>
                </a>
                <ng-container *ngIf="'Pages.Webshop.Configuration.Banner' | permission">
                    <a routerLink="webshop/configuration" class="kt-notification__item">
                        <div class="kt-notification__item-icon">
                            <i class="flaticon2-settings"></i>
                        </div>
                        <div class="kt-notification__item-details">
                            <div class="kt-notification__item-title kt-font-bold">
                                <span translation="Axilla.App.Webshop.Configuration" source="Axilla">
                                </span>
                            </div>
                        </div>
                    </a>
                </ng-container>
                <a routerLink="helper/faq" class="kt-notification__item">
                    <div class="kt-notification__item-icon">
                        <i class="flaticon2-quotation-mark"></i>
                    </div>
                    <div class="kt-notification__item-details">
                        <div class="kt-notification__item-title kt-font-bold">
                            <span>
                                {{"FAQ" | localize}}
                            </span>
                        </div>
                    </div>
                </a>
                <div class="kt-notification__custom">
                    <a (click)="logout()" class="btn btn-label-brand btn-sm btn-bold">{{"Logout" | localize}}</a>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="(isHost || ('App.ChatFeature' | checkFeature)) && !chatConnected"
         class="kt-header__topbar-item dropdown">
        <div class="kt-header__topbar-wrapper">
            <span class="kt-header__topbar-icon kt-header__topbar-icon--brand">
                <img *ngIf="!chatConnected" src="./assets/common/images/loading.gif" style="width: 23px;"
                     tooltip="{{'ChatIsConnecting' | localize}}" placement="left" />
            </span>
        </div>
    </div>
    <div id="kt_quick_sidebar_toggle" [hidden]="!(isHost || ('App.ChatFeature' | checkFeature)) || !chatConnected"
         class="kt-header__topbar-item dropdown">
        <div class="kt-header__topbar-wrapper">
            <span class="kt-header__topbar-icon kt-header__topbar-icon--brand">
                <div *ngIf="unreadChatMessageCount">
                    <i class="flaticon-chat-2 unread-notifications"></i>
                    <span class="kt-badge kt-badge--primary unread-notification-count">
                        {{unreadChatMessageCount}}
                    </span>
                </div>
                <div *ngIf="!unreadChatMessageCount">
                    <i class="flaticon-chat-2"></i>
                </div>
            </span>
        </div>
    </div>
</div>
<!-- END: Topbar -->
